(function(){
  if(window.__tkhBound) return; window.__tkhBound=true;

  function setCount(n){
    document.querySelectorAll('.tkh__count').forEach(function(el){
      el.textContent = n;
      if(n > 0){ el.removeAttribute('hidden'); } else { el.setAttribute('hidden',''); }
    });
  }

  var LOCK_CLASSES = ['scroll-lock','overflow-hidden','no-scroll','is-locked','scroll-locked','prevent-scroll'];
  function forceUnlock(){
    [document.documentElement, document.body].forEach(function(el){
      el.style.removeProperty('overflow');
      el.style.removeProperty('overflow-y');
      el.style.removeProperty('position');
      el.style.removeProperty('height');
      LOCK_CLASSES.forEach(function(c){ el.classList.remove(c); });
    });
  }
  function mnavOpen(){ var m=document.getElementById('tkhMnav'); return m && !m.hidden; }
  function anyDialogOpen(){ return !!document.querySelector('dialog[open]'); }
  function cajonAppAbierto(){ return document.documentElement.classList.contains('essential-cart__open'); }
  /* Ojo: no liberar el scroll si el cajon de la app esta abierto, o la pagina de
     detras se desplazaria por debajo del carrito. */
  function maybeUnlock(){ if(mnavOpen() || anyDialogOpen() || cajonAppAbierto()) return; forceUnlock(); }

  function openMnav(){ var m=document.getElementById('tkhMnav'); if(m){ mnavGroups(); m.hidden=false; document.documentElement.style.setProperty('overflow','hidden','important'); } }
  function closeMnav(){ var m=document.getElementById('tkhMnav'); if(m){ m.hidden=true; } forceUnlock(); }

  /* --- Icono de carrito de la cabecera ---
     Antes abria el cajon nativo de Horizon. Desde que el carrito lo gestiona la
     app Essential Cart Drawer, ese cajon ya no se usa y el icono no hacia nada.
     Ahora se llama a la API de la app (essentialCartApi.openCart). Si por lo que
     sea la app no estuviera cargada, se cae con elegancia a la pagina /cart. */
  function abrirCarrito(){
    try{
      var api = window.essentialCartApi;
      if(api && typeof api.openCart === 'function'){ api.openCart(); return true; }
    }catch(e){}
    var d = document.querySelector('cart-drawer-component');
    if(d && typeof d.open === 'function'){ try{ d.open(); return true; }catch(e){} }
    return false;
  }

  // --- Estilos propios inyectados: acordeon del menu movil + resenas ---
  function tkhCss(){
    if(document.getElementById('tkh-mnav-acc-css')) return;
    var s = document.createElement('style');
    s.id = 'tkh-mnav-acc-css';
    s.textContent = '.tkh-mnav .tkh-mnav__grp--toggle{display:flex !important;align-items:center;justify-content:space-between;gap:10px;width:100%;cursor:pointer;margin:0 !important;padding:11px 0 !important;border-top:1px solid #F6EEE8;}'
      + '.tkh-mnav .tkh-mnav__sub > .tkh-mnav__grp--toggle:first-child{border-top:none;}'
      + '.tkh-mnav .tkh-mnav__gsub{display:flex;flex-direction:column;padding:0 0 6px;}'
      + '.tkh-mnav .tkh-mnav__gsub[hidden]{display:none !important;}'
      + '.tkh-mnav .tkh-mnav__gchev{display:inline-flex;align-items:center;color:#B0A398;transition:transform .25s ease;flex:none;}'
      + '.tkh-mnav .tkh-mnav__gchev svg{width:15px;height:15px;}'
      + '.tkh-mnav .tkh-mnav__grp--toggle[aria-expanded="true"] .tkh-mnav__gchev{transform:rotate(180deg);}'
      + '.tkh-mnav .tkh-mnav__all{padding:8px 0 !important;}'
      + '.tkp__rating{display:none !important;}'
      + '.tkp__appblocks .klaviyo-star-rating-widget{margin:2px 0 10px;cursor:pointer;}';
    document.head.appendChild(s);
  }

  function mnavGroups(){
    tkhCss();
    var grps = document.querySelectorAll('.tkh-mnav__grp');
    for(var i=0;i<grps.length;i++){
      var g = grps[i];
      if(g.getAttribute('data-gacc')) continue;
      g.setAttribute('data-gacc','1');

      var wrap = document.createElement('div');
      wrap.className = 'tkh-mnav__gsub';
      wrap.hidden = true;
      var n = g.nextElementSibling;
      while(n && n.classList && n.classList.contains('tkh-mnav__gitem')){
        var next = n.nextElementSibling;
        wrap.appendChild(n);
        n = next;
      }
      if(n){ g.parentNode.insertBefore(wrap, n); } else { g.parentNode.appendChild(wrap); }

      g.classList.add('tkh-mnav__grp--toggle');
      g.setAttribute('role','button');
      g.setAttribute('tabindex','0');
      g.setAttribute('aria-expanded','false');
      var chev = document.createElement('span');
      chev.className = 'tkh-mnav__gchev';
      chev.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>';
      g.appendChild(chev);

      (function(g, wrap){
        function toggle(){
          var open = g.getAttribute('aria-expanded') === 'true';
          g.setAttribute('aria-expanded', open ? 'false' : 'true');
          wrap.hidden = open;
        }
        g.addEventListener('click', toggle);
        g.addEventListener('keydown', function(e){
          if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); toggle(); }
        });
      })(g, wrap);
    }
  }

  function navPill(){
    document.querySelectorAll('.header-menu .menu-list__link').forEach(function(a){
      var t = (a.textContent || '').trim().toLowerCase();
      if(t === 'ofertas' || t === 'sale' || t === 'rebajas' || t === 'outlet'){
        var li = a.closest('.menu-list__list-item');
        if(li){ li.classList.add('toke-navpill'); }
      }
    });
  }

  document.addEventListener('click', function(e){
    var t = e.target;
    var cart = t.closest ? t.closest('.tkh__cart') : null;
    if(cart){
      e.preventDefault();
      if(!abrirCarrito()){ window.location.href = '/cart'; }
      return;
    }
    if(t.closest && t.closest('.tkh__burger')){ e.preventDefault(); openMnav(); return; }
    if(t.closest && (t.closest('.tkh-mnav__close') || t.closest('[data-close]'))){ e.preventDefault(); closeMnav(); return; }
    if(t.closest && t.closest('.tkh-mnav a')){ var m=document.getElementById('tkhMnav'); if(m){ m.hidden=true; } forceUnlock(); }
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ closeMnav(); } });

  window.addEventListener('wheel', maybeUnlock, {passive:true});
  window.addEventListener('touchmove', maybeUnlock, {passive:true});
  window.addEventListener('resize', function(){ if(window.innerWidth >= 990){ closeMnav(); } });
  window.addEventListener('pageshow', maybeUnlock);

  /* El contador de la cabecera se actualiza con los eventos del tema y tambien
     con los de la app, para que no se quede desfasado. */
  function refrescarContador(){
    fetch('/cart.js', { headers:{'Accept':'application/json'}, credentials:'same-origin', cache:'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(c){ setCount(c.item_count); })
      .catch(function(){});
  }
  document.addEventListener('cart:update', function(ev){
    var n = (ev && ev.detail && ev.detail.resource) ? ev.detail.resource.item_count : undefined;
    if(typeof n === 'number'){ setCount(n); } else { refrescarContador(); }
  });
  function engancharApp(){
    try{
      var api = window.essentialCartApi;
      if(!api || window.__tkhAppBound) return;
      if(typeof api.onCartUpdate === 'function'){ api.onCartUpdate(function(){ refrescarContador(); }); window.__tkhAppBound = true; }
    }catch(e){}
  }

  function init(){ tkhCss(); navPill(); mnavGroups(); engancharApp(); maybeUnlock(); }
  if(document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', function(){ setTimeout(function(){ navPill(); mnavGroups(); engancharApp(); maybeUnlock(); }, 200); });
  setTimeout(engancharApp, 900); setTimeout(engancharApp, 2000);
  setTimeout(navPill, 600); setTimeout(navPill, 1400);
})();
